import { CaseTypeEnum } from 'api/model';
import Routes from 'constants/Routes';
import { useLocation } from 'react-router-dom';

const useCurrentRouteCaseType = () => {
  const location = useLocation();

  if (location.pathname.startsWith(Routes.rentedStaff.index)) {
    return CaseTypeEnum.RentedStaff;
  }
  if (location.pathname.startsWith(Routes.samakning.index)) {
    return CaseTypeEnum.Samakning;
  }
  if (location.pathname.startsWith(Routes.homeDeliveries.index)) {
    return CaseTypeEnum.HomeDelivery;
  }
  if (location.pathname.startsWith(Routes.internalDeliverySales.index)) {
    return CaseTypeEnum.InternalDeliverySales;
  }
  if (
    location.pathname.startsWith(
      Routes.internalDeliveryGroup.carTransportTrucks.index
    )
  ) {
    return CaseTypeEnum.CarTransportTruck;
  }
  if (location.pathname.startsWith(Routes.internalDeliveryGroup.index)) {
    return CaseTypeEnum.InternalDelivery;
  }
  if (location.pathname.startsWith(Routes.internalDeliveries.index)) {
    return CaseTypeEnum.InternalDelivery;
  }
  if (location.pathname.startsWith(Routes.facilityExchange.index)) {
    return CaseTypeEnum.FaciliyExchange;
  }
  if (location.pathname.startsWith(Routes.auction.index)) {
    return CaseTypeEnum.Auction;
  }
  if (location.pathname.startsWith(Routes.purchases.index)) {
    return CaseTypeEnum.Purchase;
  }
  if (location.pathname.startsWith(Routes.rmOther.index)) {
    return CaseTypeEnum.RMOther;
  }
  if (location.pathname.startsWith(Routes.avyttringar.index)) {
    return CaseTypeEnum.Avyttringar;
  }
  if (location.pathname.startsWith(Routes.garantiarenden.index)) {
    return CaseTypeEnum.Garantiarenden;
  }
  if (location.pathname.startsWith(Routes.aterTillLogistik.index)) {
    return CaseTypeEnum.AterTillLogistik;
  }
  if (location.pathname.startsWith(Routes.dackkorning.index)) {
    return CaseTypeEnum.Dackkorning;
  }
  if (location.pathname.startsWith(Routes.swamp.index)) {
    return CaseTypeEnum.Swamp;
  }
  if (location.pathname.startsWith(Routes.verkstadsbilar.index)) {
    return CaseTypeEnum.Verkstadsbilar;
  }
  if (location.pathname.startsWith(Routes.facilityToFacility.index)) {
    return CaseTypeEnum.FacilityToFacility;
  }
  if (location.pathname.startsWith(Routes.facilityTransfer.index)) {
    return CaseTypeEnum.FacilityTransfer;
  }
  if (location.pathname.startsWith(Routes.carTransportTrucks.index)) {
    return CaseTypeEnum.CarTransportTruck;
  }

  return null;
};

export const useCurrentRouteCaseRoute = () => {
  const currentRouteCaseType = useCurrentRouteCaseType();

  const location = useLocation();

  switch (currentRouteCaseType) {
    case CaseTypeEnum.Purchase:
      return Routes.purchases.case;
    case CaseTypeEnum.Auction:
      return Routes.auction.case;
    case CaseTypeEnum.RentedStaff:
      return Routes.rentedStaff.case;
    case CaseTypeEnum.Samakning:
      return Routes.samakning.case;
    case CaseTypeEnum.HomeDelivery:
      return Routes.homeDeliveries.case;
    case CaseTypeEnum.InternalDelivery:
      return Routes.internalDeliveries.case;
    case CaseTypeEnum.FaciliyExchange:
      return Routes.facilityExchange.case;
    case CaseTypeEnum.InternalDeliverySales:
      return Routes.internalDeliverySales.case;
    case CaseTypeEnum.RMOther:
      return Routes.rmOther.case;
    case CaseTypeEnum.Avyttringar:
      return Routes.avyttringar.case;
    case CaseTypeEnum.Garantiarenden:
      return Routes.garantiarenden.case;
    case CaseTypeEnum.AterTillLogistik:
      return Routes.aterTillLogistik.case;
    case CaseTypeEnum.Dackkorning:
      return Routes.dackkorning.case;
    case CaseTypeEnum.Swamp:
      return Routes.swamp.case;
    case CaseTypeEnum.Verkstadsbilar:
      return Routes.verkstadsbilar.case;
    case CaseTypeEnum.FacilityToFacility:
      return Routes.facilityToFacility.case;
    case CaseTypeEnum.FacilityTransfer:
      return Routes.facilityTransfer.case;

    default:
      if (location.pathname.startsWith(Routes.pendingAssignments.index)) {
        return Routes.pendingAssignments.case;
      }
      if (location.pathname.startsWith(Routes.viktigt.index)) {
        return Routes.viktigt.case;
      }
      if (location.pathname.startsWith(Routes.skaPaLastbil.index)) {
        return Routes.skaPaLastbil.case;
      }
      if (location.pathname.startsWith(Routes.search.index)) {
        return Routes.search.case;
      }
      return Routes.purchases.case;
  }
};

export const getRouteForCaseType = (caseType: CaseTypeEnum) => {
  switch (caseType) {
    case CaseTypeEnum.Purchase:
      return Routes.purchases.index;
    case CaseTypeEnum.Auction:
      return Routes.auction.index;
    case CaseTypeEnum.RentedStaff:
      return Routes.rentedStaff.index;
    case CaseTypeEnum.Samakning:
      return Routes.samakning.index;
    case CaseTypeEnum.HomeDelivery:
      return Routes.homeDeliveries.index;
    case CaseTypeEnum.InternalDelivery:
      return Routes.internalDeliveries.index;
    case CaseTypeEnum.FaciliyExchange:
      return Routes.facilityExchange.index;
    case CaseTypeEnum.InternalDeliverySales:
      return Routes.internalDeliverySales.index;
    case CaseTypeEnum.RMOther:
      return Routes.rmOther.index;
    case CaseTypeEnum.Avyttringar:
      return Routes.avyttringar.index;
    case CaseTypeEnum.Garantiarenden:
      return Routes.garantiarenden.index;
    case CaseTypeEnum.AterTillLogistik:
      return Routes.aterTillLogistik.index;
    case CaseTypeEnum.Dackkorning:
      return Routes.dackkorning.index;
    case CaseTypeEnum.Swamp:
      return Routes.swamp.index;
    case CaseTypeEnum.Verkstadsbilar:
      return Routes.verkstadsbilar.index;
    case CaseTypeEnum.FacilityToFacility:
      return Routes.facilityToFacility.index;
    case CaseTypeEnum.FacilityTransfer:
      return Routes.facilityTransfer.index;
    default:
      return Routes.purchases.index;
  }
};

export default useCurrentRouteCaseType;
